import { render, staticRenderFns } from "./AppDialog.vue?vue&type=template&id=4f48e163&scoped=true"
import script from "./AppDialog.vue?vue&type=script&lang=js"
export * from "./AppDialog.vue?vue&type=script&lang=js"
import style0 from "./AppDialog.vue?vue&type=style&index=0&id=4f48e163&prod&scoped=true&lang=css"
import style1 from "./AppDialog.vue?vue&type=style&index=1&id=4f48e163&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f48e163",
  null
  
)

export default component.exports